<template>
	<v-container class="text-center mt-5">
		<v-row justify="center">
			<v-col cols="12" md="8">
				<h1 class="display-1">404</h1>
				<h2 class="headline">Page non trouvée</h2>
				<v-btn color="primary" @click="goHome">Retour à l'accueil</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'NotFound',
	methods: {
		goHome() {
			this.$router.push('/');
		}
	}
};
</script>

<style scoped>
.text-center {
	text-align: center;
}
</style>